import { css } from '@emotion/react';
import { useRef } from 'react';

import { useMousePosition } from '../hooks/useMousePosition';
import { ILineString } from '../models/interfaces/ILineString';

const style = css({
    margin : '0px',
    alignItems: 'center',
    justifyContent: 'center',
    '& .geopost-seismic-mouse-position': {
        //width: 150,
        fontSize: 12,
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        columnGap: 10,
        rowGap: 5
    },
    '& .x, .y, .segment': {
        textWrap: 'nowrap',
        margin: 0,
    },
});

export function SeismicShowCoordinates (){
    const ref = useRef<HTMLDivElement>(null);
    useMousePosition(ref);

    return (<div id='mouse-position' ref={ref} css={style}></div>);
}